import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { BlendingAccordionComponent } from './blending-accordion';
import { BlendingAccordionPanelComponent } from './blending-accordion-panel/blending-accordion-panel.component';

@NgModule({
	declarations: [BlendingAccordionComponent, BlendingAccordionPanelComponent],
	imports: [
		CommonModule,
		SharedModule,
		GenericDirectivesModule
	],
	exports: [BlendingAccordionComponent, BlendingAccordionPanelComponent]
})
export class BlendingAccordionModule { }
